import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import Button from 'Components/Atoms/Button/Button';

export default function CreateTransactionSuccess({ onClose }) {
    const queryClient = useQueryClient();

    const { t } = useTranslation('providers');

    useEffect(() => {
        queryClient.invalidateQueries({ queryKey: ['transactions'] });
    }, []);

    return (
        <div className="text-center py-8">
            <div className="mb-6 flex justify-center">
                <img src="/img/icon-done.svg" alt="" />
            </div>
            <h3 className="font-medium">{t('manual-bank.transactions-imported')}</h3>
            <div className="mt-2 text-gray-500">{t('manual-bank.transactions-imported-description')}</div>
            <div className="mt-6 flex justify-center">
                <Button variant="primary" onClick={onClose}>
                    {t('manual-bank.accept')}
                </Button>
            </div>
        </div>
    );
}

CreateTransactionSuccess.propTypes = {
    onClose: PropTypes.func.isRequired,
};
